import axios from 'axios';

export default class ApiProxy {

	setAuthToken(token) {
		this.authToken = token;
	}

	setRedirectToLogin(redirectToLogin) {
		this.redirectToLogin = redirectToLogin;
	}

	setDestroyToken(destroyToken) {
		this.destroyToken = destroyToken;
	}

	fetchProtectedRoute(method, url, data) {

		return new Promise((fulfill, reject) => {
			axios({
				method,
				url,
				data,
				headers: {
					'Authorization': 'Bearer ' + this.authToken
				}
			}).then(response => {

				fulfill(response);
			}).catch(error => {

				if (error.response && error.response.status === 401) {
					this.destroyToken();
					this.redirectToLogin();
				}

				reject({
					message: error,
					status: error.response && error.response.status,
                    detail: error.response && error.response.data && error.response.data.message
				});
			});
		});
	}
}



// WEBPACK FOOTER //
// ./src/containers/ApiProxy.js